import { apiGet } from '@/features/shared/utils/dataFetching'
import { type QueryFunctionContext } from '@tanstack/react-query'

export type PlaRegion = {
  metro_id: number
  region_id: number
  retailer_id: number
  region_name: string
  store_location_id: number
  default_zip_code: string
  zip_codes_served: string[]
}

export const fetchPlaRegionById = (
  context: QueryFunctionContext<readonly ['PLA Region', { regionId: string }]>,
) => {
  const [, { regionId }] = context.queryKey

  return apiGet<PlaRegion>({
    context,
    config: { url: `/pla/regions/${regionId}` },
    fetcherName: 'fetchPlaRegionById',
  })
}
